import React from 'react';

import { ReactComponent as CircleExclamation } from '../../../assets/icons/CircleExclamation.svg';
import HorizontalCardField from '../HorizontalCardField/HorizontalCardField';
import Tooltip from '../../Tooltip/Tooltip';

import classes from './FieldBold.module.scss';

const FieldBold = ({
  name,
  className,
  title,
  value,
  classChildren,
  classValue,
  tooltip,
  contentTooltip,
  position,
  classNameTooltip,
  children
}) => {
  let content = (
    <div className={classes.values}>
      <span className={classValue}>{value}</span>
      {tooltip && (
        <Tooltip className={classNameTooltip} position={position} content={contentTooltip}>
          <CircleExclamation className={classes.tooltip} />
        </Tooltip>
      )}
    </div>
  );
  if (children) {
    content = <div className={classes.children}>{children}</div>;
  } else if ('object' === typeof value) {
    content = value.map((value, idx) => (
      <span key={idx} className={classValue}>
        {value}
      </span>
    ));
  }
  return (
    <HorizontalCardField title={title} className={className} classChildren={classChildren}>
      {content}
    </HorizontalCardField>
  );
};

export default FieldBold;
